import Vue from 'vue'
import moment from 'moment';

export const FILTERS = {
    formatDate: (value) => {
        return value ? moment(value, "x").format("DD MMM YYYY") : '';
    },

    ellipsis: (value, MAX_LEN) => {
        if (value) return value.length > MAX_LEN ? (value.slice(0, MAX_LEN) + '...') : value;
        return null;
    },
    monthOfNumber: (number) => {
        return moment(number, 'MM').format('MMMM');
    },
    friendlyNumberFormat: (n, d) => {
        let x = (''+n).length;
        let p = Math.pow;
        d = p(10,d);
        x -= x%3
        return Math.round(n*d/p(10,x))/d +" kMGTPE"[x/3]
    }
}

export const registerFilters = function () {
    Object.keys(FILTERS).forEach(key => {
        Vue.filter(key, FILTERS[key]);
    })
}